import React from 'react'
import MovieReview from './project/movieReview'
import Plantstory from './project/plantstory'
import Flattube from './project/flattube'

function Projects() {
	return ( 
		<div className="Projects" id="projects">
		<h2>Projects</h2>
		<br/>
		<Plantstory/>
		<br/>
		<MovieReview/>
		<br/>
		<Flattube/>
		</div>
	  )
}

export default Projects